
import { methodPost, methodPatch } from './methods';
import { API_INFO } from '../constants';

export async function createMerchandising(payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `products/merchandising/`;
  return methodPost(url, payload, config);
}

export async function editMerchandising(id, payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `products/merchandising/${id}/`;
  return methodPatch(url, payload, config);
}